import { Navigate, useLocation } from "react-router-dom";
import { ReactNode } from "react";
import { useAuth } from "src/contexts/AuthContext";

// Clave que usa tu apiClient
const ACCESS_TOKEN_KEY = "accessToken";

function getValidToken(): string | null {
  const t = localStorage.getItem(ACCESS_TOKEN_KEY);
  return t && t.trim() ? t.trim() : null;
}

// Props tipadas
interface ProtectedLayoutProps {
  children: ReactNode;
}

export default function ProtectedLayout({ children }: ProtectedLayoutProps) {
  const token = getValidToken();
  const location = useLocation();
  const { user } = useAuth();

  if (!token) {
    // Redirige a login relativo al basename del Router
    return <Navigate to="login" replace state={{ from: location }} />;
  }

  // Usuario con varias sucursales debe elegir antes de continuar
  const necesitaSucursal = user?.empresa && (user?.sucursales?.length ?? 0) > 1 && !user?.sucursal;
  const enSeleccionSucursal = location.pathname.includes("seleccionar-sucursal");
  if (necesitaSucursal && !enSeleccionSucursal) {
    return <Navigate to="/seleccionar-sucursal" replace />;
  }

  return <>{children}</>;
}